import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Security from "./pages/Security";
import ResponsibleDisclosure from "./pages/ResponsibleDisclosure";
import NotFound from "./pages/NotFound";
import Layout from "./components/Layout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/service" element={<Terms />} />
            <Route path="/security" element={<Security />} />
            <Route path="/responsible-disclosure" element={<ResponsibleDisclosure />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
